import { useState } from 'react';
import { Page, Card, Button, Select, BlockStack, InlineStack } from '@shopify/polaris';
import { usePaginatedResource } from '../../../shared/hooks/usePaginatedResource';
import { ErrorBanner } from '../../../shared/components/ErrorBanner';
import { DataTable } from '../../../shared/components/DataTable';
import { listConsignments } from './api';
import { consignmentToRow } from './ConsignmentRow';

const STATUS_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'pending' },
  { label: 'In transit', value: 'in_transit' },
  { label: 'Delivered', value: 'delivered' },
  { label: 'Failed', value: 'failed' },
];

const COLUMNS = [
  { id: 'order', title: 'Order' },
  { id: 'status', title: 'Status' },
  { id: 'tnt', title: 'TNT #' },
  { id: 'label', title: 'Label' },
  { id: 'created', title: 'Created' },
  { id: 'polled', title: 'Last polled' },
];

export function ConsignmentsListPage(): JSX.Element {
  const [statusFilter, setStatusFilter] = useState<string>('');

  const { items, loading, error, hasMore, loadMore } = usePaginatedResource(
    ['consignments', statusFilter],
    (api, cursor) =>
      listConsignments(api, {
        cursor,
        limit: 50,
        status: statusFilter || undefined,
      }),
  );

  return (
    <Page title="Consignments" subtitle="TNT consignment records">
      <BlockStack gap="400">
        {error ? <ErrorBanner error={error} /> : null}
        <Card>
          <Select
            label="Status filter"
            options={STATUS_OPTIONS}
            value={statusFilter}
            onChange={(v) => setStatusFilter(v)}
          />
        </Card>
        <DataTable
          columns={COLUMNS}
          rows={items.map(consignmentToRow)}
          loading={loading && items.length === 0}
          resourceName={{ singular: 'consignment', plural: 'consignments' }}
          emptyState={{ heading: 'No consignments yet' }}
        />
        {hasMore ? (
          <InlineStack align="center">
            <Button onClick={loadMore} loading={loading}>
              Load more
            </Button>
          </InlineStack>
        ) : null}
      </BlockStack>
    </Page>
  );
}
